import DollarForLogo from '../assets/DollarFor'

const dollarFor = {
  getImage: (props) => (
    <DollarForLogo className="dollar-for newLogo" {...props} />
  ),
}

export default dollarFor
